const handleFieldsData = (formValues, setFormValues, event, fieldData) => {
    let temp = { ...formValues };

    if (event) {
        if (fieldData?.action === "select-option") {
            if (event.value) {
                temp[fieldData.name] = event.value;
            }
            setFormValues({ ...temp });
            return;
        } else {
            if (event.target.type === "checkbox") {
                if (event.target.checked) {
                    temp[fieldData.name] = [...(temp[fieldData.name] || []), event.target.name];
                } else {
                    temp[fieldData.name] = (temp[fieldData.name] || []).filter(item => item !== event.target.name);
                }
                setFormValues({ ...temp });
                return;
            }

            temp[event.target.name] = event.target.value;
        }
    }

    if (fieldData) {
        if (fieldData.index !== undefined) {
            if (!temp[fieldData.name]) {
                temp[fieldData.name] = [];
            }
            temp[fieldData.name][fieldData.index] = fieldData.value;
        } else {
            temp[fieldData.name] = fieldData.value;
        }
    }

    setFormValues({ ...temp });
}

export default handleFieldsData;
